import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    onConnectPartnerSocket,
    onDeleteCurrentPartner,
    onDisconnectPartnerSocket,
    onSendInvitation,
    onResponseInvitation,
    onGetPendingPartner,
    onCancelCurrentInvitation,
    onListenNotification,
    onListenNotificationResponse,
} from "./PartnerThunk";
import { PartnerPending } from "../../domain/entities/partnerPending";
import { ResponseInvitationParams } from "../../domain/usecases/responseInvitation";

interface PartnerState {
    isLoading: boolean;
    loading: boolean;
    partnerLoading: boolean;
    cancelLoading: boolean;
    deleteLoading: boolean;
    getPartnerLoading: boolean;
    partnerRequestStatus: string;
    error?: string | undefined;
    errorPartnerResponse?: string | undefined;
    deleteResult?: boolean;
    partners: PartnerPending[] ;
    partnerResponse: ResponseInvitationParams[];
}

const initialState: PartnerState = {
    isLoading: false,
    loading: false,
    partnerRequestStatus: 'pending',
    partnerLoading: false,
    cancelLoading: false,
    deleteLoading: false,
    getPartnerLoading: false,
    deleteResult: undefined,
    errorPartnerResponse: "",
    partners: [],
    partnerResponse: [],

};

const partnerSlice = createSlice({
    name: "partner",
    initialState,
    reducers: {
        setErrorPartnerResponse: (state, action: PayloadAction<string>) => {
            state.errorPartnerResponse = action.payload;  
        },
        newPartnerReceived: (state, action: PayloadAction<PartnerPending>) => {
            state.partners.push(action.payload);
        },
        newPartnerResponse: (state, action: PayloadAction<any>) => {
            const newResponse = action.payload;

            const isResponseAlreadyInList = state.partners.some(
                response => response.user_id === newResponse.user_id
            );

            if (!isResponseAlreadyInList) {
                state.partners.push(newResponse);
            }
        },

        deletePartnerFromList: (state, action: PayloadAction<PartnerPending>) => {
            state.partners = state.partners.filter(partner => partner.user_id !== action.payload.user_id);
        },
        deleteAllPartnerFromList: (state) => {
            state.partners = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(onConnectPartnerSocket.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(onConnectPartnerSocket.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(onConnectPartnerSocket.rejected, (state, action) => {
                state.error = action.error.message;
                state.isLoading = false;
            })
            .addCase(onDisconnectPartnerSocket.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(onDisconnectPartnerSocket.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(onDisconnectPartnerSocket.rejected, (state, action) => {
                state.error = action.error.message;
                state.isLoading = false;
            })


            .addCase(onGetPendingPartner.rejected, (state, action) => {
                state.error = action.error.message;
                state.getPartnerLoading  = false;
            })
            .addCase(
                onGetPendingPartner.fulfilled,
                (state, action: PayloadAction<PartnerPending[]>) => {
                    state.getPartnerLoading  = false;
                    state.partners = action.payload;
                }
            )
            .addCase(onGetPendingPartner.pending, (state) => {
                state.getPartnerLoading  = true;
            })


            .addCase(onDeleteCurrentPartner.pending, (state) => {
                state.deleteLoading  = true;
            })
            .addCase(onDeleteCurrentPartner.fulfilled, (state) => {
                state.deleteLoading  = false;
                state.error = undefined;
            })
            .addCase(onDeleteCurrentPartner.rejected, (state, action) => {
                state.error = action.error.message;
                state.deleteLoading  = false;
            })


            .addCase(onCancelCurrentInvitation.pending, (state) => {
                state.cancelLoading  = true;
            })
            .addCase(onCancelCurrentInvitation.fulfilled, (state) => {
                state.cancelLoading  = false;
                state.error = undefined;
            })
            .addCase(onCancelCurrentInvitation.rejected, (state, action) => {
                state.error = action.error.message;
                state.cancelLoading  = false;
            })
            

            .addCase(onSendInvitation.pending, (state) => {
                state.partnerLoading = true;
            })
            .addCase(onSendInvitation.fulfilled, (state) => {
                state.partnerLoading = false;
                state.error = undefined;
            })
            .addCase(onSendInvitation.rejected, (state, action) => {
                state.error = action.error.message;
                state.partnerLoading = false;
            })


            .addCase(onResponseInvitation.pending, (state) => {
                state.partnerLoading = true;
            })
            .addCase(onResponseInvitation.fulfilled, (state) => {
                state.partnerLoading = false;
                state.error = undefined;
            })
            .addCase(onResponseInvitation.rejected, (state, action) => {
                state.error = action.error.message;
                state.partnerLoading = false;
            })
         

            .addCase(onListenNotification.pending, (state) => {
                state.partnerLoading = true;
            })
            .addCase(onListenNotification.fulfilled, (state) => {
                state.partnerLoading = false;
                state.error = undefined;
            })
            .addCase(onListenNotification.rejected, (state, action) => {
                state.error = action.error.message;
                state.partnerLoading = false;
            })

            
            .addCase(onListenNotificationResponse.pending, (state) => {
                state.partnerLoading = true;
            })
            .addCase(onListenNotificationResponse.fulfilled, (state) => {
                state.partnerLoading = false;
                state.error = undefined;
            })
            .addCase(onListenNotificationResponse.rejected, (state, action) => {
                state.error = action.error.message;
                state.partnerLoading = false;
            })

            ;
    }

});

export const {
    newPartnerReceived,
    newPartnerResponse,
    deletePartnerFromList,
    setErrorPartnerResponse,
    deleteAllPartnerFromList
} = partnerSlice.actions;

export default partnerSlice.reducer;
